const moduleMap = {
	"./exposes.config": () => {
		return __webpack_require__.e(929).then(() => (() => ((__webpack_require__(929)))));
	},
	"./Dashboard": () => {
		return Promise.all([__webpack_require__.e(215), __webpack_require__.e(995), __webpack_require__.e(192), __webpack_require__.e(250), __webpack_require__.e(445)]).then(() => (() => ((__webpack_require__(445)))));
	},
	"./Billing": () => {
		return Promise.all([__webpack_require__.e(995), __webpack_require__.e(192), __webpack_require__.e(419)]).then(() => (() => ((__webpack_require__(419)))));
	},
	"./Report": () => {
		return Promise.all([__webpack_require__.e(995), __webpack_require__.e(192), __webpack_require__.e(644)]).then(() => (() => ((__webpack_require__(644)))));
	},
	"./Subscriptions": () => {
		return Promise.all([__webpack_require__.e(215), __webpack_require__.e(995), __webpack_require__.e(192), __webpack_require__.e(250), __webpack_require__.e(112), __webpack_require__.e(477)]).then(() => (() => ((__webpack_require__(112)))));
	},
	"./Onboarding": () => {
		return Promise.all([__webpack_require__.e(995), __webpack_require__.e(192), __webpack_require__.e(250), __webpack_require__.e(765)]).then(() => (() => ((__webpack_require__(765)))));
	},
	"./EditCustomer": () => {
		return Promise.all([__webpack_require__.e(995), __webpack_require__.e(192), __webpack_require__.e(250), __webpack_require__.e(405)]).then(() => (() => ((__webpack_require__(405)))));
	},
	"./RequestDetails": () => {
		return Promise.all([__webpack_require__.e(215), __webpack_require__.e(995), __webpack_require__.e(192), __webpack_require__.e(250), __webpack_require__.e(210)]).then(() => (() => ((__webpack_require__(210)))));
	},
	"./ApprovalQueue": () => {
		return Promise.all([__webpack_require__.e(215), __webpack_require__.e(995), __webpack_require__.e(192), __webpack_require__.e(250), __webpack_require__.e(151)]).then(() => (() => ((__webpack_require__(151)))));
	},
	"./SubscriptionOnboarding": () => {
		return Promise.all([__webpack_require__.e(995), __webpack_require__.e(192), __webpack_require__.e(250), __webpack_require__.e(486)]).then(() => (() => ((__webpack_require__(486)))));
	},
	"./SubscriptionDetails": () => {
		return Promise.all([__webpack_require__.e(215), __webpack_require__.e(995), __webpack_require__.e(192), __webpack_require__.e(250), __webpack_require__.e(112), __webpack_require__.e(735)]).then(() => (() => ((__webpack_require__(735)))));
	}
};
const get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
const init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	const name = "default"
	const oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});